import React, { useEffect, type FC } from 'react';
import { type Pages } from '@src/Pages';
import { useUnmountReactAndNavigate } from '@src/hooks';

interface RedirectProps {
  pathname: typeof Pages[keyof typeof Pages]
  search?: string
}

export const Redirect: FC<RedirectProps> = ({ pathname, search = '' }) => {
  const navigate = useUnmountReactAndNavigate();

  useEffect(() => {
    navigate({ pathname, search });
  });

  return <div></div>;
};
